interface generateMailToInterface {
  to: string;
  subject: string;
  body: string;
}

export function generateMailTo({ to, subject, body }: generateMailToInterface) {
  const encodedSubject = encodeURIComponent(subject);
  const encodedBody = encodeURIComponent(body);
  return `mailto:${to}?subject=${encodedSubject}&body=${encodedBody}`;
}
